import { createReducer, on } from '@ngrx/store';
import { ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  ClearDateFrom,
  ClearDateUntil,
  ClearFilters,
  DateFromChanged,
  DateUntilChanged,
  GetStoresSuccess,
  InvoiceNumberChanged,
  LoyaltyCardChanged,
  PanelStatusChanged,
  StoreChanged,
} from '../actions/invoices.actions';
import { StoresState } from '../models/invoices.models';

export interface InvoicesState {
  panelExpanded: boolean;
  invoiceNumber: string;
  loyaltyCard: string;
  dateFrom: Date;
  dateFromFormat: string;
  dateUntil: Date;
  dateUntilFormat: string;
  storeValues: StoresState[];
  store: string;
}

const initialState: InvoicesState = {
  panelExpanded: true,
  invoiceNumber: '',
  loyaltyCard: '',
  dateFrom: new Date(0),
  dateFromFormat: '',
  dateUntil: new Date(0),
  dateUntilFormat: '',
  storeValues: [],
  store: '',
};

export const InvoicesReducer = createReducer(
  initialState,
  on(PanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(InvoiceNumberChanged, (state, { invoiceNumber }) => ({
    ...state,
    invoiceNumber,
  })),
  on(LoyaltyCardChanged, (state, { loyaltyCard }) => ({
    ...state,
    loyaltyCard,
  })),
  on(DateFromChanged, (state, { dateFrom, dateFromFormat }) => ({
    ...state,
    dateFrom,
    dateFromFormat,
  })),
  on(DateUntilChanged, (state, { dateUntil, dateUntilFormat }) => ({
    ...state,
    dateUntil,
    dateUntilFormat,
  })),
  on(ClearDateFrom, (state) => ({
    ...state,
    dateFrom: new Date(0),
    dateFromFormat: '',
  })),
  on(ClearDateUntil, (state) => ({
    ...state,
    dateUntil: new Date(0),
    dateUntilFormat: '',
  })),
  on(GetStoresSuccess, (state, { res }) => ({
    ...state,
    storeValues: res,
  })),
  on(StoreChanged, (state, { store }) => ({
    ...state,
    store,
  })),
  on(ClearFilters, (state) => ({
    ...state,
    invoiceNumber: '',
    loyaltyCard: '',
    dateFrom: new Date(0),
    dateFromFormat: '',
    dateUntil: new Date(0),
    dateUntilFormat: '',
    store: '',
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
